import request from '@/utils/request'

/**
 * 根据角色ID和设备类型获取设备ID
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function roleDeviceDeviceidListGet(data) {
  return request({
    type: 'device',
    url: 'role/device/deviceid/list/get',
    method: 'post',
    data
  })
}

/**
 * 修改角色与设备绑定
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function roleDeviceUpdate(data) {
  return request({
    type: 'device',
    url: 'role/device/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/RoleDevice.js